import { render } from "./wmsos-entrada-editar.vue?vue&type=template&id=5885c1ae"
import script from "./wmsos-entrada-editar.vue?vue&type=script&lang=js"
export * from "./wmsos-entrada-editar.vue?vue&type=script&lang=js"

import "./wmsos-entrada-editar.vue?vue&type=style&index=0&id=5885c1ae&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__